import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};

const actionHandlers = {
    [actions.FETCH_GIFT_CARD_REDEMPTION_DATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            ...payload.response.translations
        };
    }
};

export default createReducer(actionHandlers, initialState);
